<template>
  <div class="max-w-[900px] mx-auto pt-6">
    <!-- Header -->
    <h1 class="text-3xl font-bold mb-6">
      {{ isCreate ? 'Créer un article' : 'Modifier l’article' }}
    </h1>

    <form @submit.prevent="saveBlog" class="flex flex-col gap-6">

      <!-- Champ Titre -->
      <input
        v-model="blog.title"
        type="text"
        placeholder="Ajoutez un titre"
        class="w-full text-3xl font-semibold border-0 border-b focus:ring-0 focus:border-gray-400"
        required
      />

      <!-- Upload image avec preview -->
      <div class="flex flex-col gap-3">
        <label class="font-medium text-gray-700">Image mise en avant</label>
        
        <div v-if="blog.image" class="relative w-full max-h-64 overflow-hidden rounded-lg shadow">
          <img :src="blog.image" alt="preview" class="object-cover w-full" />
          <button
            type="button"
            class="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 text-xs rounded"
            @click="removeImage"
          >
            Supprimer
          </button>
        </div>

        <input
          type="file"
          accept="image/*"
          @change="handleImageUpload"
          class="border p-2 rounded bg-gray-50"
        />
      </div>

      <!-- Éditeur Quill -->
      <div>
        <label class="font-medium text-gray-700 mb-2 block">Contenu de l’article</label>
        <quill-editor
          v-model="blog.description"
          :options="editorOptions"
          class="border rounded-lg min-h-[300px] bg-white shadow"
        />
      </div>

      <!-- Bouton -->
      <div class="flex justify-end">
        <button
          type="submit"
          class="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 transition"
        >
          {{ isCreate ? 'Publier' : 'Mettre à jour' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { quillEditor } from 'vue3-quill'

const route = useRoute()
const router = useRouter()

const isCreate = computed(() => route.params.id === 'create')

const blogs = reactive([
  { id: 1, title: 'Blog numéro 1', description: '<p>Lorem ipsum...</p>', image: 'https://picsum.photos/800/400' },
  { id: 2, title: 'Blog numéro 2', description: '<p>Lorem ipsum...</p>', image: 'https://picsum.photos/800/400' },
  { id: 3, title: 'Blog numéro 3', description: '<p>Lorem ipsum...</p>', image: 'https://picsum.photos/800/400' },
])

const blog = reactive({
  id: null,
  title: '',
  description: '',
  image: ''
})

const editorOptions = {
  theme: 'snow',
  modules: {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  }
}

// Chargement si édition
onMounted(() => {
  if (!isCreate.value) {
    const existingBlog = blogs.find(b => b.id === parseInt(route.params.id))
    if (existingBlog) {
      Object.assign(blog, existingBlog)
    } else {
      router.push('/404')
    }
  }
})

// Sauvegarde blog
function saveBlog() {
  if (isCreate.value) {
    const newId = Math.max(...blogs.map(b => b.id)) + 1
    blogs.push({ id: newId, ...blog })
    router.push(`/blog/${newId}`)
  } else {
    const index = blogs.findIndex(b => b.id === blog.id)
    if (index !== -1) blogs[index] = { ...blog }
    alert('Article mis à jour avec succès !')
  }
}

// Upload image + preview
function handleImageUpload(event) {
  const file = event.target.files[0]
  if (file) {
    const reader = new FileReader()
    reader.onload = e => {
      blog.image = e.target.result
    }
    reader.readAsDataURL(file)
  }
}

function removeImage() {
  blog.image = ''
}
</script>

<style>
.ql-editor {
  min-height: 250px;
}
</style>
